import React from "react";
import Navigation from "./navigation";
import NavInfoAutograder from "./navInfoAutograder";
import markdownDocs from "./markdownDocs";
import ReactMarkdown from "react-markdown";
import { useParams } from "react-router-dom";
import docTypes from "./docTypes";
import markdownDocsLambda from "./markdownDocsLambda";
import dockerfileDocs from "./dockerfileDocs";
import readmeContent from "./readmeContent";
import logsDocs from "./logsDocs";

const Docs = () => {
    const { documentation } = useParams();

    const ret_correct_docs = () => {
        if (documentation === docTypes.DOCKER) {
            return dockerfileDocs;
        } else if (documentation === docTypes.LAMBDA) {
            return markdownDocsLambda;
        } else if (documentation === docTypes.PROGRAMMING) {
            return markdownDocs;
        } else if (documentation === docTypes.LOGS) {
            return logsDocs;
        } else {
            return "404 Docs"
        }
    }

    return (
        <>
            <Navigation info={<NavInfoAutograder />}/>
            <div className="autograder-container">
                <div className="autograder-documentation">
                    <ReactMarkdown>{ret_correct_docs()}</ReactMarkdown>
                </div>            
            </div>
        </>
    );
}

export default Docs;